import { BorderGridContainer, GridBox } from '@ahmdigital/ui';
import { isEmpty } from 'lodash/fp';

import Banner from '../../../elements/banner';
import constants from '../../../ahm-constants';
import CONTENT from './content';
import Head from '../../../../utils/head';
import RedirectAdapter from '../../../utils/redirect-adapter';

type LifeInsuranceHelpPageProps = {
  insuranceType: string;
};

const LifeInsuranceHelpPage = ({ insuranceType }: LifeInsuranceHelpPageProps) => {
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ 'income-protection': () => { meta: { title: string; description: string; }; banner: { title: string; preHeading: string; }; alert: Element; body: Element; }; life: () => { meta: { title: string; description: string; }; banner: { ...; }; alert: Element; body: Element; }; }'.
  const content = CONTENT?.[insuranceType]();

  if (isEmpty(content)) {
    return <RedirectAdapter to={constants.URLS.SALES.ERROR_404} />;
  }

  const meta = content?.meta;

  return (
    <>
      <Head titleTemplate="%s - ahm life insurance">
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
      </Head>

      <BorderGridContainer hideBorderTop>
        <Banner {...content.banner} />
        <GridBox padding="0">{content.body}</GridBox>
      </BorderGridContainer>
    </>
  );
};

export default LifeInsuranceHelpPage;
